module.exports = __webpack_public_path__ + "img/won-sign.4cf43307.svg";